// Safe error handling utility functions
export const safeStringify = (obj) => {
  if (obj === null || obj === undefined) return 'null';
  if (typeof obj === 'string') return obj;
  if (typeof obj === 'number' || typeof obj === 'boolean') return String(obj);
  
  // Handle error objects safely
  if (obj instanceof Error) {
    return obj.message || 'An error occurred';
  }
  
  // Handle validation errors (Pydantic format)
  if (obj && typeof obj === 'object') {
    // Check for Pydantic validation error format
    if (obj.type || obj.loc || obj.msg) {
      return obj.msg || 'Validation error';
    }
    
    // Check for detail field (FastAPI format)
    if (obj.detail) {
      return safeStringify(obj.detail);
    }
    
    // Try to safely serialize
    try {
      return JSON.stringify(obj);
    } catch {
      return '[Object object]';
    }
  }
  
  return String(obj);
};

export const safeErrorMessage = (error) => {
  // Handle axios error response format
  if (error.response?.data) {
    const data = error.response.data;
    
    // FastAPI validation error
    if (Array.isArray(data) && data[0]?.msg) {
      return data[0].msg;
    }
    
    // FastAPI HTTPException
    if (data.detail) {
      return safeStringify(data.detail);
    }
    
    // Generic response data
    return safeStringify(data);
  }
  
  // Handle direct error
  if (error.message) {
    return error.message;
  }
  
  return safeStringify(error);
};

export const safeToastError = (error) => {
  const message = safeErrorMessage(error);
  console.error('Safe toast error:', { error, message });
  return message;
};